import React, { useCallback } from 'react';
import { useMyUserId } from '../../../data/hooks/sessionHooks';
import ButtonLink from '../ButtonLink';
import './ScheduleMeetingButton.scss';
import { useI18n } from '../../../data/hooks/i18nHooks';

const ScheduleMeetingButton = (props) => {
    const { event, participant, relativePath = true, className = '',children, onClick } = props,
        selfId = useMyUserId(),
        params = [participant.participant_id ? `participants=${participant.participant_id}` : null, participant.id ? `users=${participant.id}` : null].filter((i) => i).join('&'),
        href = `${relativePath ? '.' : '/events/' + event.id}/participants/${participant.id || '-'}/${participant.participant_id || '-'}/invite?${params}`,
        i18n = useI18n();

    const handleClick = useCallback(function (e) {
        e.stopPropagation();
        if (onClick) onClick(e);
    }, [onClick]);

    if (selfId === participant.id) return null;
    if (!participant.status?.match(/(on|off)line$/)) return null;

    return (
        <ButtonLink className={`ScheduleMeetingButton ${className}`} href={href} style={{ backgroundColor: event.settings.primary_color }} onClick={handleClick}>
            {children ?? i18n['label.invite']}
        </ButtonLink>
    );
};

export default ScheduleMeetingButton;
